import {
  NS_GET_COMMON_MODULE_INIT,
  NS_GET_COMMON_MODULE_FAIL,
  NS_GET_COMMON_MODULE_SUCCESS
} from '../../actions/ns/common';

export const initialState = {
  commonModule: []
};

function nsCommon(state = initialState, action) {
  switch (action.type) {
    case NS_GET_COMMON_MODULE_INIT:
      return {
        ...state,
        payload: action.payload
      };
    case NS_GET_COMMON_MODULE_SUCCESS:
      return {
        ...initialState,
        commonModule: action.payload
      };
    case NS_GET_COMMON_MODULE_FAIL:
      return {
        ...state
      };
    default:
      return state;
  }
}

export default nsCommon;
